export class PrimaryChatUserInputData {
  public input: string;
  public companyIds?: number[];
  public filingIds?: string[];
  public transcriptIds?: number[];
  public userDocumentIds?: string[];

  constructor(data: any) {
    this.input = data.input;
    this.companyIds = data.companyIds;
    this.filingIds = data.filingIds;
    this.transcriptIds = data.transcriptIds;
    this.userDocumentIds = data.userDocumentIds;
  }
}
